import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            nav: {
                catalog: "Catalog",
                home: "Home",
                cart: "Basket",
                admin: "Admin",
                logout: "Log out",
                login: "Log in",
                register: "Request access",
                contact: "Contact",
                new: "New",
                search_placeholder: "Search by part number or name...",
                search_button: "Search",
                go: "Go",
            },
            home: {
                hero_browse: "Browse catalog",
                hero_new: "New arrivals",
                quick_search_placeholder: "Enter turbo code, OEM, or vehicle (e.g. 703245, GT1549S, Renault)...",
                quick_search_title: "Find your part fast.",
                quick_search_kicker: "Quick search",
                view_all: "View all →",
                view_all_results: "View all results for",
                no_matches: "No matching parts. Press Enter anyway to search.",
                section_browse: "Section 01 // Browse",
                section_catalog: "Product Catalog",
                section_oem: "Section 03 // OEM Partners",
                section_aftermarket: "Section 04 // Aftermarket",
                brands_oem: "OEM Brands",
                brands_aftermarket: "Aftermarket Brands",
                section_platform: "Section 02 // Platform",
                cta_title_1: "Curated by admin.",
                cta_title_2: "Precision in every part.",
                cta_body: "Every product, image and price in this catalog is manually curated by the Turbo Cimi team. Approved dealers get direct access to up-to-date stock and pricing.",
                cta_open_catalog: "Open catalog",
                cta_new_arrivals: "New arrivals",
                usp_oe: "OE-Grade Parts",
                usp_oe_sub: "Spec-matched",
                usp_fast: "Fast Shipping",
                usp_fast_sub: "Worldwide dispatch",
                usp_verified: "Verified Suppliers",
                usp_verified_sub: "Quality assured",
                usp_bulk: "Bulk Discounts",
                usp_bulk_sub: "For authorized dealers",
                catalog_empty: "Catalog is being populated. Check back in a moment.",
                parts: "parts",
            },
            product: {
                add_to_cart: "Add",
                added: "Added",
                adding: "Adding...",
                back_to_catalog: "Back to catalog",
                not_found: "Product not found",
                not_available: "Not available",
                in_stock: "In stock",
                on_order: "On order",
                pcs: "pcs",
                product_info: "Product info",
                category: "Category",
                brand: "Brand",
                oem_brand: "OEM Brand",
                aftermarket_brand: "Aftermarket",
                part_number: "Part number",
                pn_short: "PN",
                stock: "Stock",
                specifications: "Specifications",
                gallery: "Gallery",
                description: "Description",
                note: "Note",
                usage: "Vehicle usage",
                show_qr: "Show QR code",
                qr_title: "QR code",
                qr_print: "Print QR",
                contact_for_price: "Contact for quote",
                price: "Price",
                price_not_set: "Price not yet set by administrator. Contact admin for quote.",
                ask_admin: "Ask admin",
                see_all_brand: "See all products of this brand",
            },
            catalog: {
                title: "Catalog",
                all_catalog: "All Catalog",
                search_results: "Search",
                breadcrumb_home: "HOME",
                breadcrumb_catalog: "CATALOG",
                search_placeholder: "Search by name or part number…",
                categories: "Categories",
                all: "All",
                no_results: "No products found.",
                price: "Price",
                in_stock_only: "In-stock only",
                sort: "Sort",
                per_page: "Per page",
                sort_category: "Category order",
                sort_name_az: "Name A→Z",
                sort_name_za: "Name Z→A",
                sort_stock: "In stock first",
                parts_count: "PARTS",
                page_label: "PAGE",
                brands_oem: "OEM Brands",
                brands_aftermarket: "Aftermarket",
                currency_eur: "EUR",
                currency_lek: "Lek",
            },
            cart: {
                title: "Your basket",
                empty: "Your basket is empty.",
                continue_shopping: "Continue shopping",
                remove: "Remove",
                clear: "Clear basket",
                total: "Total",
                subtotal: "Subtotal",
                qty: "Qty",
                submit_order: "Submit order to admin",
                submitting: "Submitting...",
                note_label: "Note for admin (optional)",
                note_placeholder: "Anything the admin should know…",
                order_submitted: "Order submitted — awaiting admin confirmation.",
                item: "item",
                items: "items",
            },
            auth: {
                welcome_back: "Welcome back.",
                create_account: "Create account.",
                email: "Email",
                password: "Password",
                signing_in: "Signing in...",
                sign_in: "Sign in",
                no_account: "No account?",
                request_access: "Request access",
                have_account: "Have an account?",
                log_in: "Log in",
                full_name: "Full name",
                service_name: "Service name",
                phone: "Phone",
                address: "Address",
                nipt: "NIPT",
                optional: "optional",
                required: "required",
                creating: "Creating...",
                request_button: "Request access",
                login_kicker: "Auth · Login",
                register_kicker: "Auth · Register",
                approved_subtitle: "Approved dealers and workshops can access the full catalog, pricing, and stock.",
                pending_title: "Your account is pending admin approval.",
                pending_body: "You'll receive access as soon as an administrator reviews and approves your request.",
            },
            contact: {
                title: "Visit the workshop.",
                subtitle: "Drop by to discuss turbo rebuilds, order parts for pickup, or arrange delivery.",
                address: "Address",
                phone: "Phone",
                email: "Email",
                hours: "Hours",
                send_message: "Send a message",
                name_label: "Name",
                email_label: "Email",
                phone_label: "Phone",
                help_label: "How can we help you?",
                name_placeholder: "Your name",
                email_placeholder: "Email",
                phone_placeholder: "+355 ...",
                help_placeholder: "Tell us what you need...",
                message_placeholder: "How can we help?",
                sending: "Sending...",
                send: "Send message",
                thanks: "Thanks! We'll be in touch.",
                map_not_set: "Map location not yet set.",
                scan_for_directions: "Scan for directions",
                kicker: "Contact",
            },
            common: {
                loading: "Loading...",
                save: "Save",
                cancel: "Cancel",
                delete: "Delete",
                edit: "Edit",
                close: "Close",
                search: "Search",
                confirm: "Confirm",
                yes: "Yes",
                no: "No",
                back: "Back",
                next: "Next",
                previous: "Previous",
                none: "None",
            },
            install: {
                title: "Install Turbo Cimi",
                body: "Install our app on your phone for faster access — works offline.",
                cta: "Install",
                ios_hint: "Tap the Share icon in Safari, then 'Add to Home Screen' to install.",
            },
        },
    },
    al: {
        translation: {
            nav: {
                catalog: "Katalogu",
                home: "Kryefaqja",
                cart: "Shporta",
                admin: "Admin",
                logout: "Dil",
                login: "Kyçu",
                register: "Regjistrohu",
                contact: "Kontakt",
                new: "Të reja",
                search_placeholder: "Kërko sipas kodit ose emrit...",
                search_button: "Kërko",
                go: "Shko",
            },
            home: {
                hero_browse: "Shfleto katalogun",
                hero_new: "Të reja",
                quick_search_placeholder: "Shkruaj kodin e turbos, OEM ose automjetin (p.sh. 703245, GT1549S, Renault)...",
                quick_search_title: "Gjej pjesën tënde shpejt.",
                quick_search_kicker: "Kërkim i shpejtë",
                view_all: "Shiko të gjitha →",
                view_all_results: "Shiko të gjitha rezultatet për",
                no_matches: "S'u gjet asnjë pjesë. Shtyp Enter për të kërkuar gjithsesi.",
                section_browse: "Seksioni 01 // Shfleto",
                section_catalog: "Katalogu i Produkteve",
                section_oem: "Seksioni 03 // Partnerë OEM",
                section_aftermarket: "Seksioni 04 // Aftermarket",
                brands_oem: "Markat OEM",
                brands_aftermarket: "Markat Aftermarket",
                section_platform: "Seksioni 02 // Platforma",
                cta_title_1: "E kuruar nga admin.",
                cta_title_2: "Precizion në çdo pjesë.",
                cta_body: "Çdo produkt, foto dhe çmim në këtë katalog është i kuruar manualisht nga ekipi Turbo Cimi. Tregtarët e miratuar marrin akses direkt në stokun dhe çmimet e përditësuara.",
                cta_open_catalog: "Hap katalogun",
                cta_new_arrivals: "Të reja",
                usp_oe: "Pjesë OE-Grade",
                usp_oe_sub: "Të përputhura me spec",
                usp_fast: "Transport i shpejtë",
                usp_fast_sub: "Dërgesa në botë",
                usp_verified: "Furnitorë të verifikuar",
                usp_verified_sub: "Cilësi e garantuar",
                usp_bulk: "Zbritje për shumicë",
                usp_bulk_sub: "Për tregtarët e autorizuar",
                catalog_empty: "Katalogu po plotësohet. Ktheu pas pak.",
                parts: "pjesë",
            },
            product: {
                add_to_cart: "Shto",
                added: "U shtua",
                adding: "Duke shtuar...",
                back_to_catalog: "Kthehu te katalogu",
                not_found: "Produkti nuk u gjet",
                not_available: "I padisponueshëm",
                in_stock: "Në gjendje",
                on_order: "Me porosi",
                pcs: "copë",
                product_info: "Informacion i produktit",
                category: "Kategoria",
                brand: "Marka",
                oem_brand: "Marka OEM",
                aftermarket_brand: "Aftermarket",
                part_number: "Kodi",
                pn_short: "Kodi",
                stock: "Stoku",
                specifications: "Specifikimet",
                gallery: "Galeria",
                description: "Përshkrimi",
                note: "Shënim",
                usage: "Përdorimi në automjete",
                show_qr: "Shfaq kodin QR",
                qr_title: "Kodi QR",
                qr_print: "Printo QR",
                contact_for_price: "Kontakto për çmim",
                price: "Çmimi",
                price_not_set: "Çmimi nuk është vendosur ende nga admin-i. Kontakto admin-in për çmim.",
                ask_admin: "Pyet admin",
                see_all_brand: "Shiko të gjitha produktet e kësaj marke",
            },
            catalog: {
                title: "Katalogu",
                all_catalog: "I gjithë katalogu",
                search_results: "Kërkim",
                breadcrumb_home: "KRYEFAQJA",
                breadcrumb_catalog: "KATALOGU",
                search_placeholder: "Kërko sipas emrit ose kodit…",
                categories: "Kategoritë",
                all: "Të gjitha",
                no_results: "Asnjë produkt i gjetur.",
                price: "Çmimi",
                in_stock_only: "Vetëm në gjendje",
                sort: "Rendit",
                per_page: "Për faqe",
                sort_category: "Sipas kategorisë",
                sort_name_az: "Emri A→Z",
                sort_name_za: "Emri Z→A",
                sort_stock: "Në gjendje fillim",
                parts_count: "PJESË",
                page_label: "FAQJA",
                brands_oem: "Markat OEM",
                brands_aftermarket: "Aftermarket",
                currency_eur: "EUR",
                currency_lek: "Lek",
            },
            cart: {
                title: "Shporta juaj",
                empty: "Shporta juaj është bosh.",
                continue_shopping: "Vazhdo blerjet",
                remove: "Hiq",
                clear: "Pastro shportën",
                total: "Totali",
                subtotal: "Nëntotali",
                qty: "Sasia",
                submit_order: "Dërgo porosinë te admin",
                submitting: "Duke dërguar...",
                note_label: "Shënim për admin (opsionale)",
                note_placeholder: "Diçka që duhet ta dijë admin-i…",
                order_submitted: "Porosia u dërgua — në pritje të konfirmimit nga admin.",
                item: "artikull",
                items: "artikuj",
            },
            auth: {
                welcome_back: "Mirë se erdhe.",
                create_account: "Krijo llogari.",
                email: "Email",
                password: "Fjalëkalimi",
                signing_in: "Duke u kyçur...",
                sign_in: "Kyçu",
                no_account: "Nuk keni llogari?",
                request_access: "Kërko akses",
                have_account: "Keni llogari?",
                log_in: "Kyçu",
                full_name: "Emri i plotë",
                service_name: "Emri i servisit",
                phone: "Telefoni",
                address: "Adresa",
                nipt: "NIPT",
                optional: "opsionale",
                required: "e detyrueshme",
                creating: "Duke krijuar...",
                request_button: "Kërko akses",
                login_kicker: "Auth · Login",
                register_kicker: "Auth · Regjistrim",
                approved_subtitle: "Tregtarët dhe servisët e miratuar mund të aksesojnë katalogun e plotë, çmimet dhe stokun.",
                pending_title: "Llogaria juaj pret miratimin nga admin.",
                pending_body: "Do të merrni akses sapo një administrator të shqyrtojë dhe miratojë kërkesën tuaj.",
            },
            contact: {
                title: "Vizitoni servisin.",
                subtitle: "Kaloni për të diskutuar riparime turbosh, porositni pjesë për t'u tërhequr, ose organizoni dërgesë.",
                address: "Adresa",
                phone: "Telefoni",
                email: "Email",
                hours: "Orari",
                send_message: "Dërgo një mesazh",
                name_label: "Emri",
                email_label: "Email",
                phone_label: "Nr. telefonit",
                help_label: "Si mund t'ju ndihmoj?",
                name_placeholder: "Emri juaj",
                email_placeholder: "Email",
                phone_placeholder: "+355 ...",
                help_placeholder: "Më tregoni çfarë ju nevojitet...",
                message_placeholder: "Si mund t'ju ndihmojmë?",
                sending: "Duke dërguar...",
                send: "Dërgo mesazhin",
                thanks: "Faleminderit! Do t'ju kontaktojmë së shpejti.",
                map_not_set: "Vendndodhja në hartë nuk është vendosur.",
                scan_for_directions: "Skano për drejtime",
                kicker: "Kontakt",
            },
            common: {
                loading: "Duke ngarkuar...",
                save: "Ruaj",
                cancel: "Anulo",
                delete: "Fshij",
                edit: "Redakto",
                close: "Mbyll",
                search: "Kërko",
                confirm: "Konfirmo",
                yes: "Po",
                no: "Jo",
                back: "Pas",
                next: "Tjetër",
                previous: "I mëparshëm",
                none: "Asnjë",
            },
            install: {
                title: "Instalo Turbo Cimi",
                body: "Instaloje aplikacionin në telefon për akses më të shpejtë — punon edhe pa internet.",
                cta: "Instalo",
                ios_hint: "Shtyp ikonën Share në Safari, pastaj 'Add to Home Screen' për ta instaluar.",
            },
        },
    },
    it: {
        translation: {
            nav: {
                catalog: "Catalogo",
                home: "Home",
                cart: "Carrello",
                admin: "Admin",
                logout: "Esci",
                login: "Accedi",
                register: "Richiedi accesso",
                contact: "Contatti",
                new: "Novità",
                search_placeholder: "Cerca per codice o nome...",
                search_button: "Cerca",
                go: "Vai",
            },
            home: {
                hero_browse: "Sfoglia il catalogo",
                hero_new: "Novità",
                quick_search_placeholder: "Inserisci codice turbo, OEM o veicolo (es. 703245, GT1549S, Renault)...",
                quick_search_title: "Trova il tuo pezzo velocemente.",
                quick_search_kicker: "Ricerca rapida",
                view_all: "Vedi tutti →",
                view_all_results: "Vedi tutti i risultati per",
                no_matches: "Nessun pezzo trovato. Premi Invio per cercare comunque.",
                section_browse: "Sezione 01 // Sfoglia",
                section_catalog: "Catalogo Prodotti",
                section_oem: "Sezione 03 // Partner OEM",
                section_aftermarket: "Sezione 04 // Aftermarket",
                brands_oem: "Marchi OEM",
                brands_aftermarket: "Marchi Aftermarket",
                section_platform: "Sezione 02 // Piattaforma",
                cta_title_1: "Curato dall'admin.",
                cta_title_2: "Precisione in ogni pezzo.",
                cta_body: "Ogni prodotto, immagine e prezzo in questo catalogo è curato manualmente dal team Turbo Cimi. I rivenditori autorizzati hanno accesso diretto a stock e prezzi aggiornati.",
                cta_open_catalog: "Apri catalogo",
                cta_new_arrivals: "Novità",
                usp_oe: "Ricambi OE-Grade",
                usp_oe_sub: "Spec-matched",
                usp_fast: "Spedizione rapida",
                usp_fast_sub: "In tutto il mondo",
                usp_verified: "Fornitori verificati",
                usp_verified_sub: "Qualità garantita",
                usp_bulk: "Sconti all'ingrosso",
                usp_bulk_sub: "Per rivenditori autorizzati",
                catalog_empty: "Il catalogo è in fase di popolamento. Torna tra poco.",
                parts: "pezzi",
            },
            product: {
                add_to_cart: "Aggiungi",
                added: "Aggiunto",
                adding: "Aggiunta...",
                back_to_catalog: "Torna al catalogo",
                not_found: "Prodotto non trovato",
                not_available: "Non disponibile",
                in_stock: "Disponibile",
                on_order: "Su ordinazione",
                pcs: "pz",
                product_info: "Informazioni prodotto",
                category: "Categoria",
                brand: "Marchio",
                oem_brand: "Marchio OEM",
                aftermarket_brand: "Aftermarket",
                part_number: "Codice",
                pn_short: "Cod.",
                stock: "Scorte",
                specifications: "Specifiche",
                gallery: "Galleria",
                description: "Descrizione",
                note: "Nota",
                usage: "Utilizzo veicolo",
                show_qr: "Mostra codice QR",
                qr_title: "Codice QR",
                qr_print: "Stampa QR",
                contact_for_price: "Contatta per il prezzo",
                price: "Prezzo",
                price_not_set: "Prezzo non ancora impostato dall'amministratore. Contatta l'admin per un preventivo.",
                ask_admin: "Chiedi admin",
                see_all_brand: "Vedi tutti i prodotti di questo marchio",
            },
            catalog: {
                title: "Catalogo",
                all_catalog: "Tutto il catalogo",
                search_results: "Ricerca",
                breadcrumb_home: "HOME",
                breadcrumb_catalog: "CATALOGO",
                search_placeholder: "Cerca per nome o codice…",
                categories: "Categorie",
                all: "Tutti",
                no_results: "Nessun prodotto trovato.",
                price: "Prezzo",
                in_stock_only: "Solo disponibili",
                sort: "Ordina",
                per_page: "Per pagina",
                sort_category: "Ordine categoria",
                sort_name_az: "Nome A→Z",
                sort_name_za: "Nome Z→A",
                sort_stock: "Disponibili prima",
                parts_count: "PEZZI",
                page_label: "PAGINA",
                brands_oem: "Marchi OEM",
                brands_aftermarket: "Aftermarket",
                currency_eur: "EUR",
                currency_lek: "Lek",
            },
            cart: {
                title: "Il tuo carrello",
                empty: "Il carrello è vuoto.",
                continue_shopping: "Continua lo shopping",
                remove: "Rimuovi",
                clear: "Svuota",
                total: "Totale",
                subtotal: "Subtotale",
                qty: "Q.tà",
                submit_order: "Invia ordine all'admin",
                submitting: "Invio...",
                note_label: "Nota per l'admin (opzionale)",
                note_placeholder: "Qualcosa che l'admin deve sapere…",
                order_submitted: "Ordine inviato — in attesa di conferma.",
                item: "articolo",
                items: "articoli",
            },
            auth: {
                welcome_back: "Bentornato.",
                create_account: "Crea account.",
                email: "Email",
                password: "Password",
                signing_in: "Accesso...",
                sign_in: "Accedi",
                no_account: "Non hai un account?",
                request_access: "Richiedi accesso",
                have_account: "Hai un account?",
                log_in: "Accedi",
                full_name: "Nome completo",
                service_name: "Nome officina",
                phone: "Telefono",
                address: "Indirizzo",
                nipt: "P.IVA",
                optional: "opzionale",
                required: "richiesto",
                creating: "Creazione...",
                request_button: "Richiedi accesso",
                login_kicker: "Auth · Login",
                register_kicker: "Auth · Registrazione",
                approved_subtitle: "I rivenditori e le officine approvati possono accedere al catalogo completo, ai prezzi e alle scorte.",
                pending_title: "Il tuo account è in attesa di approvazione.",
                pending_body: "Riceverai l'accesso non appena un amministratore esaminerà e approverà la tua richiesta.",
            },
            contact: {
                title: "Vieni a trovarci.",
                subtitle: "Passate per parlare di revisioni turbo, ordinare parti, o organizzare la consegna.",
                address: "Indirizzo",
                phone: "Telefono",
                email: "Email",
                hours: "Orari",
                send_message: "Invia un messaggio",
                name_label: "Nome",
                email_label: "Email",
                phone_label: "Telefono",
                help_label: "Come possiamo aiutarti?",
                name_placeholder: "Nome",
                email_placeholder: "Email",
                phone_placeholder: "+39 ...",
                help_placeholder: "Dicci di cosa hai bisogno...",
                message_placeholder: "Come possiamo aiutarti?",
                sending: "Invio...",
                send: "Invia",
                thanks: "Grazie! Ti ricontatteremo presto.",
                map_not_set: "Posizione sulla mappa non impostata.",
                scan_for_directions: "Scansiona per indicazioni",
                kicker: "Contatti",
            },
            common: {
                loading: "Caricamento...",
                save: "Salva",
                cancel: "Annulla",
                delete: "Elimina",
                edit: "Modifica",
                close: "Chiudi",
                search: "Cerca",
                confirm: "Conferma",
                yes: "Sì",
                no: "No",
                back: "Indietro",
                next: "Avanti",
                previous: "Precedente",
                none: "Nessuno",
            },
            install: {
                title: "Installa Turbo Cimi",
                body: "Installa la nostra app sul telefono per un accesso più rapido — funziona offline.",
                cta: "Installa",
                ios_hint: "Tocca l'icona Condividi su Safari, poi 'Aggiungi a Home' per installare.",
            },
        },
    },
};

const saved = typeof window !== "undefined" ? localStorage.getItem("tc-lang") : null;

i18n.use(initReactI18next).init({
    resources,
    lng: saved || "al", // default Albanian
    fallbackLng: "en",
    interpolation: { escapeValue: false },
});

export default i18n;
